import { useWordPress } from '../context/WordPressContext';
import Spinner from './ui/Spinner';

/**
 * Route guard for WordPress-only pages (setup, products, settings, reports).
 * Requires a valid WP REST session obtained via the iframe auth bridge.
 * Does NOT require Supabase auth.
 */
export default function WpProtectedRoute({ children }) {
  const { isInWordPress, wpRestSession } = useWordPress();

  if (!isInWordPress) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-center">
        <p className="text-sm text-surface-500">This page is only available within WordPress.</p>
      </div>
    );
  }

  if (!wpRestSession) {
    return (
      <div className="flex flex-col items-center justify-center h-64 gap-3">
        <Spinner size="lg" />
        <p className="text-sm text-surface-500">Connecting to WordPress...</p>
      </div>
    );
  }

  return children;
}
